import React, { useReducer, useEffect, useState } from "react";
import { Layout, Row, Col, Button} from "antd";
import {useNavigate } from "react-router-dom";
import Navbar from "../../Navbar.js";
import { useMediaQuery } from "react-responsive";
import { CloseOutlined, CheckOutlined ,MenuOutlined} from "@ant-design/icons";
import feedbackText from "./feedbackITranslation.js";
import ExperienceRating from "../experienceRatingComponent.js/Experiencerating.js";
import ITexperience from "../serviceComponents/itExperienceComponent/itExperienceComponent.js";
import MobileTelephony from "../serviceComponents/mobileTelephonyComponent/mobileTelephonyComponent.js";
import OfficeNetworkComponent from "../serviceComponents/officeNetworkComponent/officenetwork.js";
import DigitalServiceComponent from "../serviceComponents/digitalServiceComponent/digitalServiceComponent.js";
import Submit from "../submitPageComponent/contactBackComponent.js";
import "../../Components/App.css";
import "./Feedback.css";
import MicrosoftTeamsVideoRoomComponent from "../serviceComponents/microsoftTeamsComponent/MicrosoftTeamsVideoRoom.js";
import { feedbackReducer, initialState } from '../../redux/reducers/feedbackReducer.js';
import {
  setStep,
  updateFeedback,
  removeOption,
  completeOption,
  setCurrentOptionSelected
} from '../../redux/actions/feedbackActions.js';
import { setYesNoSelected } from '../../redux/actions/msTeamsAction.js';
import { resetSelectedOption } from "../../redux/actions/philipsITAction.js";
import { openNotification } from "../../utilities.js";
import ITServiceDesk from "../serviceComponents/itServiceComponent/itService.js";
import PhilipsIT from "../serviceComponents/philipsITCloudComponent/philipsITCloudOrchestration.js";
import CommonComp from "../commonComponent/CommonComp.js";
import { useSelector } from "react-redux";
import { clearSelectedExperience } from "../../redux/actions/experienceAction.js";

const { Content } = Layout;

const FeedbackPage = () => {
  const navigate = useNavigate();
  const {
    selectedLanguage,
    selectedAnswers,
    isOptionSelected,
    experienceSelected,
    isYesNoSelectedTeams,
    isSelectedIt,
    currentOptionSelected,
    isMobileTelephonyOptionsSelected,
    isOfficeNetworkOptionSelected,
    isItExperienceOptionSelected,
    isItExperienceLocationSelected
  } = useSelector((state) => ({
    selectedLanguage: state.language.selectedLanguage,
    selectedAnswers: state.selectedSurvey.selectedAnswers,
    isOptionSelected: state.philipsIT.isOptionSelected,
    experienceSelected: state.feedback.experienceSelected,
    isYesNoSelectedTeams: state.msTeams.isYesNoSelectedTeams,
    isSelectedIt: state.itService.isSelectedIt,
    currentOptionSelected: state.feedback.currentOptionSelected,
    mainOptionSelected: state.mobileTelephony.mainOption,
    isMobileTelephonyOptionsSelected: state.mobileTelephony.isFullySelected,
    isOfficeNetworkOptionSelected: state.officeNetwork.isOptionSelected,
    isItExperienceOptionSelected: state.ITExperience.isOptionSelected,
    isItExperienceLocationSelected: state.experience.isLocationSelected
  }));

  const currentText = feedbackText[selectedLanguage] || feedbackText["English"];
  const [isMicrosoftTeamsVideoRoom, setIsMicrosoftTeamsVideoRoom] = useState(false);
  const [isITExperienceCenter, setIsITExperienceCenter] = useState(false);
  const [state, dispatch] = useReducer(feedbackReducer, {
    ...initialState,
    options: selectedAnswers,
    feedbackData: selectedAnswers.map(() => ({ overallExperience: null, comments: "" })),
  });
  const [showThanks, setShowThanks] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isExperienceRatingPage, setIsExperienceRatingPage] = useState(false);
  const [isYesNoSelected, setIsYesNoSelected] = useState(false);

  const currentAnswer = state.options[state.currentStep];
  const currentFeedback = state.feedbackData[state.currentStep] || {};

  const stepConfig = {
    "Microsoft Teams Video room": 2,
    "Philips IT cloud orchestration": 2,
    "IT Service Desk": 2,
    "IT Experience Center": 2,
    "Office network connectivity": 2,
    "Mobile telephony service": 2,
    "Digital collaboration": 2,
    "Philips Personal Computer systems": 1, 
    "Philips voice cloud": 2,
    "Philips asset library": 2,
    "Philips product library": 2,
    "Health care - MP1 - Commercial": 2,
    "Health care imaging and ultrasound": 2,
    "Planisware": 2,
    "Conga (Apttus) CPQ CLM": 2,
    "Salesforce cCRM": 2,
    "IT Portal": 2,
    "TrackWise": 2,
    "ServiceMax": 2,
    "Windchill application": 2,
    "Azure DevOps": 1,
    "GitHub": 1,
    "Artifactory": 1,
    "SonarQube": 1,
    "CodeScene": 1,
    "Coverity": 1,
    "Other Applications": 2,
    "Otra Aplicación": 2,
    "Andere Applicatie": 2,
    "Autre Application": 2,
    "その他のアプリケーション": 2,  
    "其他应用程序": 2, 
    "Weitere Anwendungen":2,
  };

  useEffect(() => {
    const selectedOption = state.options[state.currentStep];
    if (selectedOption !== currentOptionSelected) {
      dispatch(setCurrentOptionSelected(currentAnswer));
    }
  }, [state.currentStep, state.options, currentOptionSelected, currentAnswer]);

  useEffect(() => {
    if (state.currentSubStep === 0) {
      dispatch(setYesNoSelected(isMicrosoftTeamsVideoRoom ? true : false));
    }
  }, [state.currentStep, state.currentSubStep, isMicrosoftTeamsVideoRoom]);

  useEffect(() => {
    const selectedOption = state.options[state.currentStep];
    setIsMicrosoftTeamsVideoRoom(selectedOption === "Microsoft Teams Video room" && state.currentSubStep === 0);
  }, [state.currentStep, state.currentSubStep, state.options]);

  useEffect(() => {
    const selectedOption = state.options[state.currentStep];
    setIsITExperienceCenter(selectedOption === "IT Experience Center" && state.currentSubStep === 0);
  }, [state.currentStep, state.currentSubStep, state.options]);

  useEffect(() => {
    dispatch(clearSelectedExperience());
  }, [state.currentStep, dispatch]);
  


  const handleExperienceChange = (option, value) => {
    dispatch(updateFeedback(option, "overallExperience", value));
  };

  const handleCommentChange = (option, e) => {
    dispatch(updateFeedback(option, "comments", e.target.value));
  };

  const handleYesNoSelect = (option, response) => {
    dispatch(updateFeedback(option, "yesNoAnswer", response));
  };


  const handleNext = () => {
    const maxSubStep = stepConfig[state.options[state.currentStep]] - 1;
    const isLastSubStep = state.currentSubStep === maxSubStep;
    const isLastOption = state.currentStep >= state.options.length - 1;

    if (isLastSubStep && isLastOption) {
      setIsCompleted(true);
    } else if (isLastSubStep) {
      dispatch(completeOption(state.options[state.currentStep]));
      dispatch(setStep(state.currentStep + 1, 0));
    } else {
      dispatch(setStep(state.currentStep, state.currentSubStep + 1));
    }
  };

  const handleBack = () => {
    const isFirstSubStep = state.currentSubStep === 0;

    if (isFirstSubStep && state.currentStep > 0) {
      const prevMaxSubStep =
        stepConfig[state.options[state.currentStep - 1]] - 1;
      dispatch(setStep(state.currentStep - 1, prevMaxSubStep));
    } else {
      dispatch(setStep(state.currentStep, state.currentSubStep - 1));
    }
    dispatch(resetSelectedOption());
  };

  const handleSubmitFeedback = () => {
    const feedbackToSubmit = {
      feedbackData: state.feedbackData,
    };
  };

  const renderStepContent = () => {
    if (isCompleted) {
      return <Submit onSubmit={handleSubmitFeedback} />;
    }
    const componentMap = {
      "Microsoft Teams Video room": {
        0: (
          <MicrosoftTeamsVideoRoomComponent
            onYesNoSelect={(answer) => {
              dispatch(updateFeedback("yesNoAnswer", answer));
              dispatch(setYesNoSelected(true));
            }}
          />
        ),
        1: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience}
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
      },
      "Philips IT cloud orchestration": {
        0: <PhilipsIT />,
        1: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience} 
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
      },
      "IT Service Desk": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience}
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
        1: (
          <ITServiceDesk
            onYesNoSelect={(answer) => {
              dispatch(updateFeedback("yesNoAnswer", answer));
              setIsYesNoSelected(true);
            }}
            commentValue={currentFeedback.comments}
            onCommentChange={handleCommentChange}
            showThanks={showThanks}
            setShowThanks={setShowThanks}
          />
        ),
      },
      "IT Experience Center": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience} 
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
        1: <ITexperience />,
      },
      "Office network connectivity": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience} // Adjust this to reference `currentOption`
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
        1: <OfficeNetworkComponent />,
      },
      "Mobile telephony service": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback.overallExperience}
            onExperienceChange={handleExperienceChange}
            commentValue={currentFeedback.comments}
            onCommentChange={handleCommentChange}
          // onSelectionChange={}
          />
        ),
        1: <MobileTelephony />,
      },
      "Digital collaboration": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience} 
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),
        1: <DigitalServiceComponent />,
      },
      "Philips Personal Computer systems": {
        0: (
          <ExperienceRating
            key={currentAnswer}
            currentOption={currentAnswer}
            overallExperience={currentFeedback?.overallExperience} 
            onExperienceChange={(value) => handleExperienceChange(currentAnswer, value)}
            commentValue={currentFeedback?.comments}
            onCommentChange={(e) => handleCommentChange(currentAnswer, e)}
          />

        ),        
      }
    };

    const componentForStep = componentMap[currentAnswer]?.[state.currentSubStep];

    if (componentForStep) {
      const isCurrentlyExperienceRating = componentForStep.type === ExperienceRating;
      if (isCurrentlyExperienceRating !== isExperienceRatingPage) {
        setIsExperienceRatingPage(isCurrentlyExperienceRating);
      }
    } else {
      const isCurrentlyExperienceRating = state.currentSubStep === 0;
      if (isCurrentlyExperienceRating !== isExperienceRatingPage) {
        setIsExperienceRatingPage(isCurrentlyExperienceRating);
      }
    }

    if (componentForStep) {
      return componentForStep;
    }

    const defaultComponent =
      state.currentSubStep === 0 ? (
        <ExperienceRating
          key={currentAnswer}
          currentOption={currentAnswer}
          overallExperience={currentFeedback.overallExperience}
          onExperienceChange={handleExperienceChange}
          commentValue={currentFeedback.comments}
          onCommentChange={handleCommentChange}
        />
      ) : (
        <CommonComp currentOption={currentAnswer} />
      );

    return defaultComponent;
  };

  const stepConditions = {
    "IT Service Desk": {
      subStep: 1,
      condition: () => !isSelectedIt,
    },
    "Philips IT cloud orchestration": {
      subStep: 0,
      condition: () => !isOptionSelected,
    },
    "Mobile telephony service": {
      subStep: 1,
      condition: () => !isMobileTelephonyOptionsSelected,
    },
    "Office network connectivity": {
      subStep: 1,
      condition: () => !isOfficeNetworkOptionSelected,
    },
    "IT Experience Center": {
      subStep: 1,
      condition: () => !isItExperienceOptionSelected,
    },
  };

  const isMicrosoftTeamsVideoRoomCondition = isMicrosoftTeamsVideoRoom && !isYesNoSelectedTeams;
  const isExperienceRatingCondition = !experienceSelected[currentAnswer] && isExperienceRatingPage;
  const isITExperienceCenterCondition = isITExperienceCenter && !isItExperienceLocationSelected;

  const stepCondition = stepConditions[state.options[state.currentStep]];
  const isStepConditionMet =
    stepCondition &&
    stepCondition.subStep === state.currentSubStep &&
    stepCondition.condition();

  const isNextButtonDisabled =
    isMicrosoftTeamsVideoRoomCondition ||
    isExperienceRatingCondition ||
    isITExperienceCenterCondition ||
    isStepConditionMet;

    const isMobile = useMediaQuery({ maxWidth: 768 }); // Detect mobile screens
    const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <Layout>
      {!isMobile ? (
        /*** Desktop Layout ***/
        <>
          <Navbar />
          <Layout.Content>
            <Row className="feedback-row">
              <Col
                style={{
                  borderTop: "1.3px solid rgba(128, 128, 128,0.5)",
                  borderRight: "1.3px solid rgba(128, 128, 128,0.5)",
                }}
                span={6}
                className="feedback-col"
              >
                <header className="header">
                  <h4 className="title">{currentText.headerTitle}</h4>
                  <p className="description">{currentText.headerDescription}</p>
                </header>
                <ul className="numbered-list">
                  {state.options.map((option, index) => (
                    <li
                      key={index}
                      className={`tag ${
                        isCompleted
                          ? "completed"
                          : state.currentStep === index
                          ? "active"
                          : state.completedOptions.includes(option)
                          ? "completed"
                          : "inactive"
                      }`}
                    >
                      <div className="list-item">
                        <span className="list-circle">
                          {state.completedOptions.includes(option) ||
                          isCompleted ? (
                            <CheckOutlined />
                          ) : (
                            <span>{index + 1}</span>
                          )}
                        </span>
                        <span className="option-text">{option}</span>
                        <Button
                          className="remove-button"
                          type="link"
                          onClick={() => {
                            if (state.options.length > 1) {
                              dispatch(removeOption(option));
                            } else {
                              openNotification(
                                "warning",
                                "You must have at least one option selected."
                              );
                            }
                          }}
                        >
                          <CloseOutlined className="close-icon" />
                        </Button>
                      </div>
                    </li>
                  ))}
                </ul>
              </Col>
              <Col
                style={{ borderTop: "1.3px solid rgba(128, 128, 128,0.5)", display: "flex", flexDirection: "column", minHeight: "calc(100vh - 64px)", overflow: "auto" }}
                span={18}
                className="question-col"
              >
                <div style={{ flex: 1 }}>
                  {renderStepContent()}
                </div>

                {!isCompleted && (
                  <div
                    style={{
                      position: "sticky",
                      bottom: "0px",
                      display: "flex",
                      justifyContent: "center",
                      padding: "16px 0",
                      background: "white",
                      zIndex: 9999,
                    }}
                  >
                    <Button
                      style={{
                        borderRadius: "20px",
                        color: "black",
                        border: "1px solid black",
                      }}
                      onClick={
                        state.currentStep === 0 && state.currentSubStep === 0
                          ? () => navigate("/question")
                          : handleBack
                      }
                    >
                      Back
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleNext}
                      disabled={isNextButtonDisabled}
                      style={{ marginLeft: "16px", borderRadius: "20px" }}
                    >
                      Next
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </Layout.Content>
        </>
      ) : (
        /*** Mobile Layout ***/
        <>
        <Layout.Content style={{ minHeight: "100vh", overflow: "auto" }}>
          <Navbar />
          
  <Row className="feedback-row">
    {/* Sidebar */}
    <div
      style={{
        position: "absolute",
        left: isCollapsed ? "-500px" : "0",
        top: "35px",
        bottom: 0,
        width: "85%",
        backgroundColor: "#F1FAFE",
        padding: "35px",
        transition: "all 0.3s ease",
        zIndex: 1000,
        boxShadow: isCollapsed ? "none" : "2px 0px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <button
        style={{
          position: "absolute",
          top: "50px",
          right: "10px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "18px",
        }}
        onClick={() => setIsCollapsed(true)}
      >
        <CloseOutlined />
      </button>

      {!isCollapsed && (
        <>
          <header className="header">
            <h4 className="title">{currentText.headerTitle}</h4>
            <p className="description">{currentText.headerDescription}</p>
          </header>

          <ul className="numbered-list">
            {state.options.map((option, index) => (
              <li
                key={index}
                className={`tag ${
                  isCompleted
                    ? "completed"
                    : state.currentStep === index
                    ? "active"
                    : state.completedOptions.includes(option)
                    ? "completed"
                    : "inactive"
                }`}
              >
                <div className="list-item">
                  <span className="list-circle">
                    {state.completedOptions.includes(option) || isCompleted ? (
                      <CheckOutlined />
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </span>
                  <span className="option-text">{option}</span>
                  <Button
                    className="remove-button"
                    type="link"
                    onClick={() => {
                      if (state.options.length > 1) {
                        dispatch(removeOption(option));
                      } else {
                        openNotification(
                          "warning",
                          "You must have at least one option selected."
                        );
                      }
                    }}
                  >
                    <CloseOutlined className="close-icon" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>

    {/* Main Content Area */}
    <div
      style={{
        backgroundColor: "white",
        padding: "16px",
        position: "relative",
        transition: "all 0.3s ease",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      {isCollapsed && (
        <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "white", // White strip background
          padding: "5px", // Padding inside the strip
          borderRadius: "6px", // Optional: Rounded corners
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)", // Optional: Adds depth
          zIndex: 1100,
          //marginBottom: "10px", // Adds space BELOW the strip
        }}
      >
        <button
          style={{
            padding: "8px 12px",
            backgroundColor: "#00438A0F",
            color: "black",
            borderRadius: "4px",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => setIsCollapsed(false)}
        >
          <MenuOutlined />
        </button>
      </div>
      
      
      )}

      {/* Scrollable Content Wrapper */}
      <div
        style={{
          flexGrow: 1, // Takes up available space
          overflowY: "auto", // Enables scrolling
          paddingBottom: "60px",
          paddingTop:"20px"
        }}
      >
        {renderStepContent()}
      </div>

      {/* Bottom Buttons */}
      {!isCompleted && (
        <div
          style={{
            position: "sticky",
            bottom: "0",
            left: "0",
            width: "100%",
            height: "50px",
            background: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
          }}
        >
          <Button
            style={{
              borderRadius: "20px",
              color: "black",
              border: "1px solid black",
            }}
            onClick={
              state.currentStep === 0 && state.currentSubStep === 0
                ? () => navigate("/question")
                : handleBack
            }
          >
            Back
          </Button>
          <Button
            type="primary"
            onClick={handleNext}
            disabled={isNextButtonDisabled}
            style={{ marginLeft: "16px", borderRadius: "20px" }}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  </Row>
</Layout.Content>


        </>
      )}
    </Layout>
  );
};

export default FeedbackPage;
